const DIALOG_CONTAINER_SELECTOR = '.cdk-overlay-container .mat-mdc-dialog-container, .cdk-overlay-container .mat-dialog-container';
const SELECT_PANEL_SELECTOR = '.mat-select-panel, .mat-mdc-select-panel';
const DIALOG_ACTIONS_SELECTOR = 'mat-dialog-actions, [mat-dialog-actions], .mat-mdc-dialog-actions';
const PRIMARY_BUTTON_SELECTOR =
    'button.mat-flat-button:not([disabled]), button.mat-mdc-unelevated-button:not([disabled]), button.mat-raised-button:not([disabled])';

const PRIMARY_ACTION_LABELS = ['Login', 'Anlegen', 'Speichern', 'Anmelden', 'Kontakt erstellen', 'Registrieren'];

function getTopmostDialogContainer(): Element | null {
    const containers = document.querySelectorAll(DIALOG_CONTAINER_SELECTOR);
    if (containers.length === 0) {
        return null;
    }
    return containers[containers.length - 1];
}

function clickDialogPrimaryButton(container: Element): void {
    const submitButton = container.querySelector('button[type="submit"]:not([disabled])') as HTMLButtonElement | null;
    if (submitButton) {
        submitButton.click();
        return;
    }

    const buttons = Array.from(container.querySelectorAll(PRIMARY_BUTTON_SELECTOR));
    for (const label of PRIMARY_ACTION_LABELS) {
        const match = buttons.find(button => button.textContent?.trim().includes(label));
        if (match) {
            (match as HTMLButtonElement).click();
            return;
        }
    }

    const actions = container.querySelector(DIALOG_ACTIONS_SELECTOR);
    if (actions) {
        const accentButton = actions.querySelector(PRIMARY_BUTTON_SELECTOR) as HTMLButtonElement | null;
        accentButton?.click();
    }
}

/**
 * When a Material dialog is open, Enter should submit that dialog (primary action)
 * instead of triggering stepper/page actions behind the overlay.
 *
 * @returns true if the event was handled and the caller should return early
 */
export function handleEnterKeyForOverlayDialog(event: KeyboardEvent): boolean {
    const container = getTopmostDialogContainer();
    if (!container) {
        return false;
    }

    const target = event.target as HTMLElement | null;

    if (target?.closest(SELECT_PANEL_SELECTOR)) {
        event.stopPropagation();
        return true;
    }

    event.preventDefault();
    event.stopPropagation();

    if (target?.closest('mat-checkbox, mat-radio-button, mat-slide-toggle')) {
        return true;
    }

    const form = target?.closest('form');
    if (form && target?.closest(DIALOG_CONTAINER_SELECTOR) === container) {
        const tag = target?.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA') {
            form.requestSubmit();
            return true;
        }
    }

    clickDialogPrimaryButton(container);
    return true;
}
